export default __webpack_public_path__ + "static/media/windsorChair.32b152fa.svg";